module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('header-bar'), _vm._v(" "), _c('BodyBudget')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3850f906"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 94
// module chunks = 1